<svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.5 5.5L0 11H1.6L7.1 5.5L1.6 0H0L5.5 5.5Z" fill="#93949A" />
</svg>
